import { DynamicCampaign as DynamicCampaignComponent } from './../components/dynamicCampaign';
import { getDynamicCampaign } from '../actions/thunkActions';
import { connect } from 'react-redux';
export const mapStateToProps = (state)=>{
    return {
        dynamicCampaign: state.dynamicCampaign
    };
};
const Campaign = connect(mapStateToProps)(DynamicCampaignComponent);
export default Campaign;
export const ensureAsyncDataSSR = (dispatch, getState, params, request)=>{
    request.params.id = params.id;
    request.params.publisher = params.publisher;
    return dispatch(getDynamicCampaign(request));
};
